import React from 'react';
import { connect } from 'react-redux';
import Wrapper from 'ui/Wrapper';
import TracksBySelectedDay from 'features/TracksBySelectedDay';
import ProductsContainer from 'features/Products';
import RacesCarusel from 'features/RacesCarusel/index';
import { showModal } from 'common/actions/uiActions';
import { getConfigByUrls } from 'configs/user-area';
import OverviewQuickPick from 'features/QuickPick/OverviewQuickPick';
import { byPlatform, isTerminal, omitMobile } from 'utils/platforms';
import { setProductShortcut } from 'features/AISDataProvider/actions';
import NotificationConductor from 'common/conductors/NotificationConductor';
import AISDataProvider from 'features/AISDataProvider';
import { isMobile } from 'react-device-detect';
import axios from 'axios';
import { getDefaultRace } from 'common/selectors/racesSelector';
import { addBet } from 'features/BetSlipState/actions';
import getTexts from 'utils/localization';
import { isModalShown } from 'common/selectors/uiSelector';
import * as RaceNavigation from 'ui/RaceNavigation';
import { HomepageRaceCalendar } from 'features/RaceCalendar';
import { checkURL, history, isOnPath } from 'utils/navigation';
import {
    mitIdErrorHandler,
    mitIdSuccessHandler,
} from 'features/Signup2/helpers';
import { isUserLoggedIn } from 'common/actions/authActions';
import TerminalBetslip from 'features/BetSlip/TerminalPopup';
import { terminal } from 'configs/layout';
import persistentStorage from '../features/PersistentStorage';

const t = getTexts();

class Home extends React.Component {
    state = {
        fastTrackUrl: '',
    };

    componentDidMount() {
        if (this.props.authorized) {
            this.checkUrlForuserAreaPopup();
        }
        this.checkCprConfirmUrl();
        this.checkSignupURL();
        this.checkLoginURL();
        this.checkMitidRedirect();

        !isMobile &&
            this.props.authorized &&
            axios
                .post('/heste/media/fasttrack/getUrl')
                .then(({ data }) => {
                    data.success && this.setState({ fastTrackUrl: data.data });
                })
                .catch((e) => {
                    console.log(`Impossible to get fast track URL`);
                });
    }

    componentDidUpdate(prevProps) {
        if (
            (prevProps.authPending && !this.props.authPending) ||
            (!prevProps.authorized && this.props.authorized) ||
            prevProps.pathname !== this.props.pathname
        ) {
            this.checkUrlForuserAreaPopup();
        }
    }

    checkUrlForuserAreaPopup = () => {
        const path = history.location.pathname.replace('/', '');
        const userAreaPopupUrls = getConfigByUrls();

        if (userAreaPopupUrls[path]) {
            this.props.authorized
                ? this.props.showUserAreaModal()
                : this.props.showLoginPromptModal();
        }
    };

    checkCprConfirmUrl = () => {
        const path = history.location.pathname.replace('/', '');
        if (path.indexOf('mitid-verify/confirm') > -1) {
            const idp = this.props?.match?.params?.type || '';
            this.props.showCprConfirmationModal(idp);
        }
    };

    checkSignupURL = () => {
        const path = history.location.pathname.replace('/', '');
        if (['opret-konto', 'opret'].includes(path)) {
            this.props.showSignupModal();
        }
    };

    checkLoginURL = () => {
        const path = history.location.pathname.replace('/', '');
        if (
            ['log-ind', 'login', 'testing/log-ind'].includes(path) &&
            !this.props.isLoginModalShown
        ) {
            if (isOnPath('/testing/log-ind')) {
                persistentStorage.save({ isItInitialLogin: true });
            }

            this.props.showLoginModal();
        }
    };

    checkMitidRedirect = () => {
        if (checkURL('mitid-verify/success')) {
            mitIdSuccessHandler(
                this.props.showModal,
                this.props.history,
                this.props.match,
                this.props.isUserLoggedIn
            );
        }

        if (checkURL('mitid-verify/error')) {
            mitIdErrorHandler(this.props.showModal, this.props.history);
        }
    };

    onClickHandler = (e) => {
        NotificationConductor.error(t.Live.authErrorMessage);
    };

    renderNavigationLayout = () => {
        const showLabels = !isMobile;

        return (
            <RaceNavigation.Grid>
                <>
                    {omitMobile(
                        <RaceNavigation.RaceNavigationLabel>
                            Dato
                        </RaceNavigation.RaceNavigationLabel>
                    )}
                    <HomepageRaceCalendar />
                </>
                <>
                    {showLabels && (
                        <RaceNavigation.RaceNavigationLabel>
                            Bane
                        </RaceNavigation.RaceNavigationLabel>
                    )}
                    <TracksBySelectedDay />
                </>
                <>
                    {showLabels && (
                        <RaceNavigation.RaceNavigationLabel
                            style={byPlatform({}, { marginTop: '-7px' })}
                        >
                            Spiltype
                        </RaceNavigation.RaceNavigationLabel>
                    )}
                    <ProductsContainer />
                </>
            </RaceNavigation.Grid>
        );
    };

    render() {
        return (
            <Wrapper padding="0px" data-test-id="home-page-betting-root">
                {isTerminal && (
                    <div style={{ position: 'sticky', top: '140px' }}>
                        <TerminalBetslip />
                    </div>
                )}

                {isTerminal ? (
                    <div style={{ width: terminal.homepage.wrapperWidth }}>
                        {this.renderNavigationLayout()}
                    </div>
                ) : (
                    this.renderNavigationLayout()
                )}

                <AISDataProvider
                    urlParams={this.props.match ? this.props.match.params : {}}
                    history={this.props.history}
                />

                <RacesCarusel
                    raceIndex={
                        this.props.match &&
                        this.props.match.params &&
                        this.props.match.params.race
                            ? this.props.match.params.race - 1
                            : this.props.defaultRace
                                ? this.props.defaultRace.index
                                : 0
                    }
                />

                {byPlatform(null, <OverviewQuickPick size={3} />)}
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    isUserAreaModalShown: isModalShown(state, 'USER_AREA'),
    isLoginModalShown: isModalShown(state, 'LOGIN'),
    authorized: state.auth.login.success,
    productShortcut: state.AISDataProvider.productShortcut,
    selectedRaceDay: state.AISDataProvider.selectedRaceDay,
    raceDayData: state.AISDataProvider.raceDayData,
    racingCardFetched: state.AISDataProvider.racingCardFetched,
    shortcutSelected: state.AISDataProvider.productShortcut,
    defaultRace: getDefaultRace(state),
    loginInitiated: state.auth.login.initiated,
    authPending: state.auth.pending,
    pathname: history.location.pathname,
});

const mapDispatchToProps = (dispatch) => {
    return {
        showUserAreaModal: () => {
            dispatch(showModal('USER_AREA_MENU'));
        },
        setProductShortcut: (product) => {
            dispatch(setProductShortcut(product));
        },
        showCprConfirmationModal: (idp) => {
            dispatch(
                showModal('CPR_CONFIRMATION', 1, {
                    openedByInitialURL: true,
                    idp,
                })
            );
        },
        showSignupModal: () => {
            dispatch(showModal('SIGNUP', 1, { openedByInitialURL: true }));
        },
        showLoginModal: () => {
            dispatch(showModal('LOGIN', 1, { openedByInitialURL: true }));
        },
        showLoginPromptModal: () => {
            dispatch(showModal('LOGIN_PROMPT', 1));
        },
        showModal: (modalId, priority = 0, modalData) => {
            dispatch(showModal(modalId, priority, modalData));
        },
        addBet: (date, trackId, productId, raceNr, startNr, betValue) => {
            dispatch(
                addBet(date, trackId, productId, raceNr, startNr, betValue)
            );
        },
        isUserLoggedIn: () => dispatch(isUserLoggedIn()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Home);
